/**
 * Centralized API configuration
 * Automatically detects the backend URL based on the current environment.
 * - Production: Same origin (API served by same server)
 * - Development: localhost:5001 or network IP:5001
 */

const getApiUrl = () => {
    // Check if we're in the browser
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        const protocol = window.location.protocol;
        const port = window.location.port;

        // In production (Railway, etc.) - API is on same origin, no port needed
        // Also handles HTTPS on standard ports (443, 80)
        if (!port || port === '80' || port === '443' || port === '') {
            return `${protocol}//${hostname}`;
        }

        // Local development - use port 5001 on the same host
        if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.')) {
            return `${protocol}//${hostname}:5001`;
        }
    }

    // Default fallback
    return process.env.REACT_APP_API_URL || 'http://localhost:5001';
};

export const API_BASE_URL = getApiUrl();
export const API_URL = `${API_BASE_URL}/api`;

console.log('🚀 API Base URL configured as:', API_BASE_URL);
